import * as yup from 'yup'

import { address, physicalAddress } from '@sputnik/schema/creditApplication/address'

export const businessAddressFormValidationSchema = yup.object().shape({
  physicalAddress: physicalAddress.nullable(),
  mailingAddress: address.nullable(),
  mailingPhysicalAddressesEqual: yup.boolean().default(true),
})

export type BusinessAddressFormValidationSchema = yup.InferType<typeof businessAddressFormValidationSchema>
